import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { cn } from "@-/com.npmjs.cn";
import { useScopedBack } from "@-/dev.improve.haniverse.routes.nav._lib.back";
import { View } from "@-/com.npmjs.react-native";

export function LevelNotFound({
  character,
  className,
  description,
  title = "Level not found",
}: {
  character: string;
  className?: string;
  description?: string;
  title?: string;
}) {
  const { canGoBack, goBack } = useScopedBack();
  const resolvedDescription =
    description ??
    `No lesson exists for this character. It may not be in your study path or the content database yet.`;

  return (
    <View className={cn("flex-1 items-center justify-center gap-4 px-6", className)}>
      <Text className="text-7xl leading-none font-semibold text-muted-foreground/70">
        {character}
      </Text>
      <View className="max-w-sm items-center gap-2">
        <Text className="text-center text-xl font-semibold text-foreground">{title}</Text>
        <Text className="text-center text-base text-muted-foreground">{resolvedDescription}</Text>
      </View>
      {canGoBack ? (
        <Button className="mt-2" onPress={() => goBack()} variant="outline">
          <Text>Go back</Text>
        </Button>
      ) : null}
    </View>
  );
}
